import { useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import Input, { TextArea } from "../../components/partials/inputs";
import PrimaryBtn from "../../components/partials/btn";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../../components/modals/successmodal";
import { useApiCall } from "../../data/useFetcher";

const RequestDetails = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(""),
    { state } = useLocation(),
    { onSubmitAPI, loading } = useApiCall();

  const onSubmit = async (data: "Accepted" | "Rejected") => {
    await onSubmitAPI({
      url: `/api/v1/auth/recommendation`,
      type: "put",
      data: { recommendation: state?._id, statusText: data },
      toggleModal: () => {
        setModal("success");
      },
      loadingValue: data,
    });
  };

  return (
    <div>
      <MainContainer>
        <div>
          <h1 className="text-3xl font-semibold text-sec">Requests</h1>
          <p className="text-base font-normal text-es-gray-100 my-2">
            Kindly review the provided details
          </p>
          <form action="" className="mt-6">
            <div className="space-y-4 w-96">
              <Input
                bg="#F9FAFB"
                label="Enter Organisation Name*"
                footer="Do not enter abbreviations"
                placeholder="Kantango Limited"
                value={state?.organizationName}
                readonly
              />
              <Input
                bg="#F9FAFB"
                label="Enter Focal Person Email*"
                placeholder="Larryngo@gmail.com"
                value={state?.email}
                readonly
              />
              {state?.country && (
                <Input
                  bg="#F9FAFB"
                  label="Country of Operation*"
                  placeholder="Nigeria"
                  value={state?.country}
                  readonly
                />
              )}
              <TextArea
                bg="#F9FAFB"
                label="Tell us a bit about the organisation"
                placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                value={state?.description}
                readonly
              />
            </div>
            <div className="mt-8  gap-8 items-center w-96 grid grid-cols-2">
              {/* <button onClick={() => navigate(-1)}>Reject</button> */}
              <PrimaryBtn
                className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium"
                text="Reject"
                width="w-full"
                disabled={!!loading}
                onClick={() => onSubmit("Rejected")}
                loading={loading === "Rejected"}
                loadingColor="#2070B8"
              />
              <PrimaryBtn
                text="Accept"
                width="w-full"
                disabled={!!loading}
                onClick={() => onSubmit("Accepted")}
                loading={loading === "Accepted"}
              />
            </div>
          </form>
        </div>
        {modal === "success" && (
          <SuccessModal
            title="Request Accepted"
            desc="An invitation email has been automatically sent to the organisation email address"
            btnText="Continue"
            page="/requests"
          />
        )}
      </MainContainer>
    </div>
  );
};

export default RequestDetails;
